exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#view.survey-view {\n  margin-left: 0px; }\n\n.survey-form-display {\n  display: flex;\n  justify-content: space-between;\n  min-height: calc(100vh - 62px);\n  flex-direction: column;\n  margin: -20px; }\n\n.survey-form-actions-display {\n  margin: auto 0 0; }\n\n@media (max-width: 768px) {\n  .survey-form-display {\n    min-height: calc(100vh - 42px); } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/survey/survey.scss
// module id = 1474
// module chunks = 0